export default __webpack_public_path__ + "static/media/index.5ecebd79.less";